import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModelVariantList from './ModelVariantList';
import { getModelVariantManager, getUserProfileWidget, getCurrentTimezone, getUserOrgModelCategoryType } from '../../selectors/index';
import { getModelVariantsThunk, setCurrentPage, setPageFilter, setFilteredDataThunk } from '../../actions/modelVariant';

const mapStateToProps = state => {
  return {
    modelVariantManager: getModelVariantManager(state),
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state),
    userModelCategories: getUserOrgModelCategoryType(state)

  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getModelVariants: (modelId, organisationId, offset, limit, filter, modelCategoryId) =>
        getModelVariantsThunk(modelId, offset, limit, filter, 'MODELVARIANTLIST', organisationId, modelCategoryId),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
      setFilterData: filteredData => setFilteredDataThunk(filteredData)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelVariantList);
